import { cn } from "@/lib/utils";

export default function MetalToggle({ value, onChange, testId = "metal-toggle" }) {
  return (
    <div
      data-testid={testId}
      className="inline-flex items-center rounded-full bg-brand-sand2 border border-brand-line-faint p-1"
    >
      {[
        { v: "gold", label: "Gold", ring: "from-yellow-500 to-amber-400" },
        { v: "silver", label: "Silver", ring: "from-slate-300 to-zinc-400" },
      ].map((o) => (
        <button
          key={o.v}
          data-testid={`${testId}-${o.v}`}
          onClick={() => onChange(o.v)}
          className={cn(
            "h-8 px-4 rounded-full text-xs font-semibold transition-transform active:scale-95 flex items-center gap-1.5",
            value === o.v
              ? o.v === "gold"
                ? "bg-gold-gradient text-brand-page shadow-gold"
                : "bg-gradient-to-r from-zinc-300 to-slate-400 text-brand-page shadow-soft"
              : "text-brand-slate hover:text-brand-cream"
          )}
        >
          <span
            className={cn(
              "h-2 w-2 rounded-full",
              o.v === "gold" ? "bg-brand-primary" : "bg-slate-300",
              value === o.v && "bg-brand-page"
            )}
          />
          {o.label}
        </button>
      ))}
    </div>
  );
}
